import CopyUrlSection from './CopyUrlSection';
import OidcActionButtons from './OidcActionButtons';
import UIStrings from '@/Utils/UIStrings';

function OidcErrorBody() {
    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-1">
                <p className="text-foreground text-base font-semibold md:text-lg">
                    {UIStrings.DueToSecurityReasonsWeCouldNotAuthenticateYourRequest}
                </p>
                <p className="text-foreground text-base font-semibold md:text-lg">{UIStrings.PleaseTryAgain}</p>
            </div>
            <OidcActionButtons />
            <CopyUrlSection />
        </div>
    );
}

export default OidcErrorBody;
